import { LocalizedTypography } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Divider, Stack } from '@optimus-web/core';
import { Date } from '@mews/framework';
import { TerminalPaymentsFeatureToggle } from './TerminalPaymentsFeatureToggle';
import { OnlinePaymentsFeatureToggle } from './OnlinePaymentsFeatureToggle';

interface ConfigurationSectionProps {
    isMulticurrencyServiceEnabled: boolean;
    isDccMulticurrencyServiceEnabled: boolean;
    isFxMulticurrencyServiceEnabled: boolean;
    isDccMulticurrencyServiceAvailable: boolean;
    multicurrencyStartDate: Date | null;
    isFetching: boolean;
}

export const ConfigurationSection = ({
    isMulticurrencyServiceEnabled,
    isDccMulticurrencyServiceEnabled,
    isFxMulticurrencyServiceEnabled,
    isDccMulticurrencyServiceAvailable,
    multicurrencyStartDate,
    isFetching,
}: ConfigurationSectionProps) => (
    <Stack vertical spacing="200">
        <LocalizedTypography
            as="h2"
            textKey={TextKey.MulticurrencySettingsConfigurationHeading}
            textStyle="titleSmallStrong"
        />
        <LocalizedTypography
            as="p"
            textKey={TextKey.MulticurrencySettingsConfigurationDescription}
            textStyle="bodyMedium"
        />

        <Divider />

        <OnlinePaymentsFeatureToggle
            isActive={isFxMulticurrencyServiceEnabled}
            isFetching={isFetching}
            isDccMulticurrencyServiceEnabled={isDccMulticurrencyServiceEnabled}
            isMulticurrencyServiceEnabled={isMulticurrencyServiceEnabled}
            multicurrencyStartDate={multicurrencyStartDate}
        />

        {isDccMulticurrencyServiceAvailable && (
            <TerminalPaymentsFeatureToggle
                isActive={isDccMulticurrencyServiceEnabled}
                isFetching={isFetching}
                isFxMulticurrencyServiceEnabled={isFxMulticurrencyServiceEnabled}
                isMulticurrencyServiceEnabled={isMulticurrencyServiceEnabled}
                multicurrencyStartDate={multicurrencyStartDate}
            />
        )}
    </Stack>
);
